import { useGetStrings } from "@app/store/service/cmsService"
import { useGetObjects } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { handleKeyboardSelect } from "@app/utils/accessibility"
import { selectObjectGroups } from "@app/utils/selectors"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect, useRef, useState } from "react"

export function Hotspot({ map, hotspot, show, onClick, tags }) {
	const textRef = useRef(null)
	const svgRef = useRef(null)
	const { data: objects } = useGetObjects({ zoneId: appStore.get("core.zoneId") })
	const {
		data: { hotspotLabel },
	} = useGetStrings()
	const selectedObjectGroupIds = useSelector(selectObjectGroups)
	const availableLoungers = useSelector(state => state.order.availableLoungers)
	const [count, setCount] = useState(0)

	useEffect(() => {
		if (textRef.current) {
			textRef.current.innerHTML = count
		}
	}, [count])

	useEffect(() => {
		if (objects && availableLoungers) {
			let cnt = 0
			//filter all objects that fits with our selected loungerTypes
			let groups = objects.filter(e => selectedObjectGroupIds.indexOf(e.objectGroupId) !== -1)

			//concat all existing objectIds
			let availableLoungerIds = availableLoungers.reduce((old, next) => {
				return old.concat(next.objectIds || [])
			}, [])

			//calc the count of the hotspot
			//all with same hotspotId and existing in availableLoungers
			groups.forEach(group => {
				let loungers = group.objects.filter(e => e.hotspotId === hotspot.hotspotId && availableLoungerIds.indexOf(e.objectId) !== -1)
				if (tags && tags.length) {
					loungers = loungers.filter(e => e.tagIds && tags.every(sId => e.tagIds.indexOf(sId) !== -1))
				}
				cnt += loungers.length
				//filter all loungers that have min one tags of the selected tags
			})

			setCount(cnt)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [objects, availableLoungers, selectedObjectGroupIds, tags])

	useEffect(() => {
		if (!show) {
			// Clean up existing element if hidden
			if (svgRef.current) {
				svgRef.current.remove()
				svgRef.current = null
			}
			return
		}

		const group = document.createElementNS("http://www.w3.org/2000/svg", "g")
		group.setAttribute("tabindex", "0")
		group.setAttribute("data-hotspot-id", hotspot.hotspotId)
		group.setAttribute("role", "button")

		if (hotspotLabel) {
			const label = hotspotLabel.replace("${hotspotId}", hotspot.hotspotId).replace("${count}", count)
			group.setAttribute("aria-label", label)
		}

		group.classList.add("hotspot-group")
		group.classList.add("clickable")

		const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle")
		circle.setAttributeNS(null, "cx", hotspot.x)
		circle.setAttributeNS(null, "cy", hotspot.y)
		circle.setAttributeNS(null, "r", 50 + hotspot.quantity * 1.5)
		circle.setAttributeNS(null, "fill", "rgb(75,152,211)")
		circle.setAttributeNS(null, "stroke", "rgba(75,152,211,0.5)")
		circle.setAttributeNS(null, "stroke-width", 50 + hotspot.quantity)
		circle.classList.add("hotspot")

		const text = document.createElementNS("http://www.w3.org/2000/svg", "text")
		text.setAttributeNS(null, "text-anchor", "middle")
		text.setAttributeNS(null, "dominant-baseline", "middle")
		text.setAttributeNS(null, "alignment-baseline", "middle")
		text.setAttributeNS(null, "fill", "white")
		text.setAttributeNS(null, "font-size", "4em")
		text.setAttributeNS(null, "x", hotspot.x)
		text.setAttributeNS(null, "y", hotspot.y + 5)
		text.setAttribute("aria-hidden", "true")
		text.classList.add("hotspot-text")
		text.classList.add("clickable")
		text.textContent = count
		text.innerHTML = count
		text.hotspot = hotspot

		group.appendChild(circle)
		group.appendChild(text)

		group.onclick = event => onClick(event, hotspot)

		group.onkeydown = event => {
			handleKeyboardSelect(event, () => onClick(event, hotspot))
		}

		svgRef.current = group
		textRef.current = text
		map.appendChild(group)

		return () => {
			group.remove()
			svgRef.current = null
			textRef.current = null
		}
	}, [map, hotspot, count, onClick, show, hotspotLabel])

	return null
}
